import { call, takeLatest } from "redux-saga/effects";
import * as settingsApis from "../apis/settingsApis"
import { COMPANY_EDIT, COMPANY_VIEW } from "../actions/types";

export function* companyViewWorker(action) {
    try {
        const res = yield call(settingsApis.companyViewApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* companyEditWorker(action) {
    try {
        const res = yield call(settingsApis.companyEditApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}


export function* companyViewWatcher() {
    yield takeLatest(COMPANY_VIEW, companyViewWorker);
}

export function* companyEditWatcher() {
    yield takeLatest(COMPANY_EDIT, companyEditWorker);
}

